import { useParams } from 'react-router-dom';

export function useEntityId(): string {
  const { id, endorsement_id } = useParams<{ id: string; endorsement_id?: string }>();
  if (!id) throw new Error('useEntityId called outside entity route');
  return endorsement_id ?? id;
}
